import { render } from "./AppointmentPage.vue?vue&type=template&id=7d0b917b&scoped=true"
import script from "./AppointmentPage.vue?vue&type=script&lang=js"
export * from "./AppointmentPage.vue?vue&type=script&lang=js"

import "./AppointmentPage.vue?vue&type=style&index=0&id=7d0b917b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d0b917b"]])

export default __exports__